import { initSentry } from './sentry.config';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import getStore from './store';
import { App } from './App';
import { GtProvider } from './components/temp-custom-ui-components';

initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('app-root') as HTMLElement,
);

root.render(
  <GtProvider store={getStore()}>
    <App />
  </GtProvider>,
  // <React.StrictMode>
  //   <GtProvider store={getStore()}>
  //     <App />
  //   </GtProvider>
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
